export function fmtDashboardDateTime(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("en-GB", {
      weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function fmtDashboardOccurrence(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("en-GB", { weekday: "short", day: "numeric", month: "short" });
  } catch {
    return iso;
  }
}

export function guestFilterLabel(filter) {
  if (!filter) return null;
  switch (filter.id) {
    case "first_timer":
      return "First-timers";
    case "beginner_level":
      return "Beginner skill";
    case "hide_name":
      return "Hidden on public list";
    case "dance_form":
      return filter.name;
    case "dance_level":
      return `${filter.name} · ${filter.level}`;
    default:
      return null;
  }
}
